import React from 'react';
import { observer } from 'mobx-react-lite';
import { Wheel } from './wheel';
import { TimerAndResult } from './timerAndResult';
import { gameStore } from '../../../store';
import { candyDataStore } from '../../../store/candyDataStore';

export const Wheels = observer(() => {
  const { currentWheelType, gameAnim, multiplierData } = candyDataStore;
  const firstWheelType = 3;
  const { time } = gameStore;
  return (
    <>
      <div
        className={`dream-wheel-circle-holder change-wheel${currentWheelType || firstWheelType}`}
      >
        <Wheel wheelType={currentWheelType} animData={gameAnim} />
      </div>
      <TimerAndResult
        isShowTimer={
          time ||
          time === 0 ||
          !multiplierData ||
          (currentWheelType && currentWheelType === firstWheelType)
        }
      />
    </>
  );
});
